export default {
  en: 'English',
  arab: 'العربية',
  activates_0:
    '1) تنظيم وعقد الاجتماعات نصف السنوية لرجال الأعمال العرب والصينيين تحت مسمى  " منتدى رجال الأعمال العرب الصينيين "  في الدول العربية والمقاطعات الصينية التي ترغب في استضافة مثل هذه الاجتماعات.',
  activates_1:
    '2) تنظيم وعقد  الاجتماعات نصف السنوية في   مجالات التجارة والصناعة والزراعة والسياحة      والنقل والمقاولات والبنوك أو أي قطاعات اقتصادية أخرى بهدف التنسيق بين رجال الأعمال العرب   والصينيين العاملين في هذه المجالات.',
  activates_2:
    '3) تنظيم المؤتمرات التجارية (B2B) والمعارض الدائمة والموسمية في الدول العربية ومقاطعات   الصين.',
  activates_3: '4) إعداد الدراسات الاقتصادية المتخصصة.',
  activates_4: '5) إنشاء وإدارة المجمعات التجارية وصالات العرض في المحافظات العربية والصينية.',
  activates_5:
    '6) العمل كرابط يربط بين الوزارات والمؤسسات والمنظمات والمنظمات العربية والصينية لتسهيل العلاقات الاقتصادية وتقليل العقبات أمام تدفق الأموال والأشخاص والبضائع بين الدول العربية والصين.',
  activates_6:
    '7) تمثيل الوزارات والمؤسسات والمنظمات العربية والصينية عند التعامل مع المؤسسات الأجنبية المماثلة',
  activates_7:
    '8) المشاركة في الاجتماعات العربية والصينية والدولية المتعلقة بأنشطة رجال الأعمال العرب والصينيين.',
  activates_8:
    '9) فتح قنوات التعاون مع المجموعات الاقتصادية الإقليمية لتحقيق مكاسب مختلفة لمجتمع الأعمال العربي الصيني',
  activates_9:
    '10) تنظيم دورات وندوات تدريبية عامة وقطاعية في الدول العربية أو المقاطعات الصينية أو في عواصم العالم لإظهار دور وأهمية منتدى الأعمال العربي الصيني كجهة راعية لأنشطة رجال الأعمال العرب والصينيين.',
  activates_10:
    '11) إصدار الدليل التجاري العربي الصيني والنشرات الإرشادية بشكل دوري باللغات العربية والصينية والإنجليزية',
  activates_11: '12) إنشاء بوابة ويب متخصصة للمتخصصين.',
  activates_12:
    '13) النظر في كافة النزاعات التجارية بين الشركات العربية والصينية أو بينها وبين الغير سواء كانوا أشخاصاً طبيعيين أو اعتباريين.',
  activates_13: '14) تقديم الاستشارات القانونية المتخصصة في العقود التجارية.',
  activates_14: '15) صياغة وكتابة العقود التجارية المحلية والإقليمية والدولية.',
  activates_15: '16) الرصد القانوني ومتابعة تنفيذ العقود التجارية.',
  activates_16: '17 ) توقيع مذكرة تعاون مع الاتحاد العربي لتجارة الاستيراد والتصدير',
  arabAfrican_0: 'أهداف المنتدى:',
  arabAfrican_1:
    'يهدف الملتقى إلى خلق التفاعل وتعزيز الروابط والتعاون والتنسيق بين رجال الأعمال العرب ورجال الأعمال الصينيين من مختلف القطاعات الاقتصادية لتعزيز التكامل الاقتصادي العربي الصيني وذلك لتحقيق الأهداف التالية:',
  arabAfrican_2:
    '1) توثيق وتطوير العلاقات الاقتصادية بين رجال الأعمال العرب والصينيين في إطار مبادرة طريق الحرير.',
  arabAfrican_3:
    '2) زيادة حجم التبادل التجاري بين الدول العربية والصين وبحث البرامج والآليات التي تحقق ذلك وتحديد المعوقات ووضع الحلول العملية التي تساعد على إزالتها.',
  arabAfrican_4:
    '3) التعاون مع المؤسسات العربية والصينية المعنية بتنمية التجارة العربية البينية والاستفادة من برامج هذه المؤسسات المالية والفنية والتأكيد على أهمية دورها في تعزيز العمل الاقتصادي العربي الصيني المشترك.',
  arabAfrican_5: '4) تعزيز المشاريع العربية الصينية المشتركة في إطار تكاملي طويل الأمد',
  arabAfrican_6:
    '5) تقديم سلسلة من العروض الخاصة ببيئة الاستثمار في الصين والتجارب الصناعية والمسار المؤسسي الناجح والاستفادة من التجارب وتبادل الخبرات بين المشاركين.',
  arabAfrican_7: '6) خلق بيئة عمل نموذجية وفتح آفاق جديدة لرجال وسيدات الأعمال العرب والصينيين.',
  arabAfrican_8:
    '7) تطوير أفكار رائدة تعود بالنفع على الاقتصاد العربي من خلال بناء المشاريع المشتركة وتطوير الصناعات.',
  arabAfrican_9: '8) تنظيم الأنشطة الاقتصادية وتنشيط الأعمال وفرص الاستثمار والشراكة والاستثمار.',
  general_01: 'الأمانة العامة',
  general_02:
    'المملكة العربية السعودية - دولة الإمارات العربية المتحدة - سلطنة عمان - مملكة البحرين - دولة قطر - جمهورية العراق - دولة لبنان - دولة فلسطين - دولة ليبيا - المملكة المغربية - الجمهورية الجزائرية الديمقراطية الشعبية - جمهورية الصين الشعبية - جمهورية أوكرانيا',
  ContactUs_01: 'رئاسة الاتحاد:',
  ContactUs_02: 'مصر',
  ContactUs_03: 'مقر الأمانة العامة:',
  ContactUs_04: 'مدينة الخرطوم - جمهورية السودان',
  ContactUs_05: 'اسم جهة الاتصال:',
  ContactUs_06: 'الايميل',
  ContactUs_07: 'الهاتف:',
  ContactUs_08: 'الموقع الإلكتروني:',
  ContactUs_09: 'المكاتب الصينية:',
  ContactUs_10: 'شيآن، مقاطعة شنشي، الصين',
  Establishment_01:
    'الاتحاد هو منظمة عربية دولية تعمل تحت مسمى  " اتحاد المصدرين والمستوردين العرب "  وهو أحد الاتحادات العربية المتخصصة العاملة في نطاق مجلس الوحدة الاقتصادية العربية وفقاً لاتفاقية الأحكام الأساسية التي صادق عليها مجلس النواب العربي وجلالة وفخامة ملوك ورؤساء الدول العربية وقد صدر قرار انضمام الاتحاد إلى مجلس الوحدة الاقتصادية العربية خلال الدورة العادية الثالثة والثمانين المنعقدة بالقاهرة بتاريخ: 7/6/2006 وصدر قرار الانضمام برقم: 1310/د83 الصادر بتاريخ: 7/6/2006',
  Establishment_02: 'تأسيس الاتحاد:',
  Establishment_03:
    'تأسس الاتحاد على يد السيدة أمل حسن زكي، وتم الإعلان عن تأسيسه بتاريخ: 25/12/2005',
  genral_01: 'مسعد عبد الحميد راشد',
  genral_02:
    'أمين عام لاتحاد المصدرين والمستوردين العرب أمين عام منتدى الأعمال العربي الأفريقي الصيني siag رئيس مجلس إدارة الشركة العربية لصناعة السيارات SHARKEYAT رئيس جمعية الأسرة مستشار الاتحاد العام لمصنعي البلاستيك مؤسس ورئيس المركز العربي للاقتصاد المعلوماتي',
  Media_01: 'فيديو',
  Media_02: 'صورة',
  Presideency_01: 'من هي أمل:',
  Presideency_02:
    'مؤهلة بكالوريوس معاملات مالية وتجارية جامعة القاهرة 1996. المناصب: سفيرة النوايا الحسنة للسلام والصحة وحقوق الإنسان (المعهد الكندي)، رئيسة مجلس إدارة شركة النيل للتسويق والاستثمار التجاري، شركة مساهمة مصرية للعمل الاجتماعي، رئيسة مجلس إدارة جمعية السجناء وأسرهم، القاهرة-- الاتحاد العربي للعمل الاقتصادي للاتحادات المتخصصة، رئيسة اتحاد المصدرين والمستوردين العرب، عضو مجلس إدارة الاتحاد العام لمنتجي ومصنعي البلاستيك في الوطن العربي التابع لمجلس الوحدة الاقتصادية (جامعة الدول العربية) منذ 14/5/1998',
  Presideency_03:
    'الاتحاد هو منظمة عربية دولية تعمل تحت مسمى  " اتحاد المصدرين والمستوردين العرب "  وهو أحد الاتحادات العربية المتخصصة العاملة في نطاق مجلس الوحدة الاقتصادية العربية وفقاً لاتفاقية الأحكام الأساسية التي صادقت عليها المجالس النيابية العربية وجلالة وفخامة ملوك ورؤساء الدول العربية وقد صدر قرار انضمام الاتحاد إلى مجلس الوحدة الاقتصادية العربية خلال الدورة العادية الثالثة والثمانين المنعقدة بالقاهرة بتاريخ: 7/6/2006م وصدر قرار الانضمام رقم: 1310/د83 الصادر بتاريخ: 7/6/2006م',
  services_01: '1. تنمية وتوطيد العلاقات الاقتصادية بين الدول العربية.',
  services_02: '2. دعم وتطوير قطاع الاستثمار في الدول العربية.',
  services_03:
    '3. دعم وتطوير القطاعات الاقتصادية العربية باستخدام أساليب وتقنيات الإدارة والإنتاج الحديثة.',
  services_04: '4. تنمية التبادل التجاري بين الدول العربية والدول الصديقة.',
  services_05: '5. إنشاء مواقع التجارة الإلكترونية.',
  services_06: '6. توطين الصناعات التكنولوجية المتقدمة في الدول العربية.',
  services_07: '7. نقل التكنولوجيا الحديثة.',
  services_08: '8. إنشاء وإدارة الشركات العربية.',
  services_09: '9. إنشاء وإدارة البنوك والمؤسسات المالية التجارية.',
  services_10: '10. إدارة الاستثمار في المشاريع الجديدة والقائمة والمتعثرة.',
  services_11: '11. إنشاء وإدارة مراكز التحكيم الدولي.',
  services_12: '12. إنشاء وإدارة مراكز البحوث والدراسات الدولية.',
  services_13: '13. إقامة علاقات وثيقة مع الحكومات والاتحادات والهيئات والمؤسسات العربية.',
  services_14: '14. إقامة علاقات تعاون مع الجهات الأجنبية ذات الصلة بمجال ونشاط الاتحاد.',
  services_15: '15.إنشاء وإدارة مركز متخصص للجودة.',
  services_16: '16.التعاون والمشاركة مع مراكز الجودة العالمية.',
  services_17: '17.إنشاء وإدارة المعاهد والجامعات والأكاديميات العالمية المتخصصة.',
  services_18: '18.توقيع وإدارة وتسويق الوكالات التجارية.',
  services_19: '19.إعداد دراسات السوق العربية والدولية.',
  services_20: '20.إعداد المؤشرات والبيانات التسويقية والاقتصادية عن الأسواق العربية والدولية.',
  services_21: '21.تنظيم وإدارة معارض المنتجات ومستلزمات الإنتاج.',
  services_22: '22.تنظيم وإدارة المؤتمرات والندوات والملتقيات التجارية (B2B).',
  services_23: '23.إصدار المجلات والنشرات والدوريات والإعلام الاقتصادي المتخصص.',
  services_24: '24.إصدار دليل المصدرين والمستوردين العرب الدوليين.',
  home_title: 'مجلس الوحدة الاقتصادية العربية',
  home_title1: 'اتحاد المصدرين والمستوردين العرب',
  router_link_01: 'صندوق الإستثمار العربي',
  router_link_02: 'بنك الصادرات العربي',
  router_link_04: 'مجموعة النحلة العربية',
  router_link_06: 'المدينة الإقتصادية',
  router_link_08: "ARAB-BEE",
  footer_01: 'المقدمة',
  footer_02: 'من نحن',
  footer_03: 'اتفاقية المستخدم',
  footer_04: 'سياسة اللوجستيات',
  footer_05: 'سياسة الإرجاع',
  footer_06: 'السلامة والأمان',
  footer_07: 'الاستيراد والتصدير',
  footer_08: 'الشركاء',
  footer_09: 'البحث عن الطلبات',
  footer_10: 'البحث عن التجار',
  footer_11: 'اتصل بنا',
  footer_12: 'الهاتف',
  footer_13: 'العنوان:رقم 6، تشونغ قوان تسون،مبنى لونغتشانغ للتكنولوجيا منطقة هايديان، بكين ',
  footer_14: '1',
  footer_15: 'طرق الدفع',
  footer_16: '© حقوق النسخ: اتحاد المصدرين والمستوردين العرب',
  menu_text_01: 'الرئيسية',
  menu_text_09: 'رئاسة الإتحاد',
  menu_text_10: 'الأمانة العامة',
  menu_text_06: 'المكاتب الإقليمية',
  menu_text_08: 'الصين',
  menu_left_text_01: 'من نحن',
  menu_left_text_02: 'الأنشطة والخدمات',
  menu_left_text_03: 'الدراسات',
  menu_left_text_04: 'المشاريع',
  menu_left_text_05: 'المعارض',
  menu_left_text_06: 'التدريب',
  menu_left_text_07: 'الجودة',
  menu_left_text_08: 'إتصل بنا',
  aboutUs_01:
    'اتحاد المصدرين والمستوردين العرب - أحد الاتحادات العربية النوعية المتخصصة العاملة في نطاق مجلس الوحدة الاقتصادية العربية، وفقًا لاتفاقية الأحكام الأساسية التي صادق عليها البرلمانات العربية وجلالة وفخامة ملوك ورؤساء الدول العربية، ومؤسسة الاتحاد السيدة أمل حسن زكي حسن، وقرار انضمام الاتحاد إلى مجلس الوحدة الاقتصادية العربية صدر قرار الوحدة خلال الدورة العادية الثالثة والثمانين المنعقدة بالقاهرة بتاريخ: 7/6/2006م، وصدر قرار الانضمام رقم:1310/د 83',
  back_lang: 'الرجوع',
  video: 'فيديو',
  'UnionBoard.8Gme5mfj': 'اتحاد المصدرين والمستوردين العرب',
  'UnionBoard.HRBBTx53': 'أعضاء المجلس',
  'UnionBoard.86nSA4X3': 'رئيس مجلس الإدارة',
  'UnionBoard.DD6jetpk': 'الأمانة العامة',
  'UnionBoard.CxFZtH5K': 'القسم',
  'UnionBoard.GJ4d367G': 'البحث',
  'UnionBoard.t6n5NAZR': 'مهام التدريب',
  'UnionBoard.cr5eYhbx': 'التجارة',
  'UnionBoard.taabRmfh': 'الاستثمار',
  'UnionBoard.hPCbRnc8': 'الخدمة',
  'UnionBoard.myYhdhpZ': 'الصناعة',
  'UnionBoard.6icpnnXY': 'الزراعة',
  'UnionBoard.dj8MQDea': 'العلاقات الدولية',
  'UnionBoard.sB45NFYz': 'المشروع',
  'UnionBoard.3SCMjAWa': 'صندوق الاستثمار العربي',
  'UnionBoard.Zzhx7n8E': 'المتجر الإلكتروني',
  'UnionBoard.Nt46ZsF8': 'بنك الصادرات العربي',
  'UnionBoard.DzbsZaYA': 'الشركة العربية للتجارة الإلكترونية',
  'UnionBoard.mXMrirBt': 'الشركة العربية للخدمات المالية',
  'UnionBoard.3YTXDC6E': 'الشركة العربية للخدمات اللوجستية',
  'UnionBoard.4maA4Rw8': 'الشركة العربية للاستثمار الرياضي',
  'UnionBoard.QkiRK6Dk': 'الأكاديمية العربية للاقتصاد المعلوماتي',
  'UnionBoard.GP3KYx66': 'المركز الدولي للوساطة والتحكيم والوساطة',
  'UnionBoard.2X4sCxRA': 'المركز العربي للمعلومات الاقتصادية',
  'UnionBoard.HdJXEwKW': 'المركز العربي للتدريب',
  'UnionBoard.jwisQzdk': 'منتدى الأعمال العربي الأفريقي الصيني',
  'UnionBoard.HZH4KHPF': 'سكرتير مساعد',
  'UnionBoard.aYSMFCFW': 'إجراءات التخطيط والمتابعة',
  'UnionBoard.8bWX2tsk': 'مؤهلات العضوية',
  'UnionBoard.r8wApYWd': 'التنمية البشرية',
  'UnionBoard.wA7ZcwpQ': 'الحساب',
  'UnionBoard.GnxiyPSw': 'الصحافة',
  'UnionBoard.YiSmrWAN': 'المعلومات الفنية',
  'UnionBoard.Dd6DPTQe': 'إدارة المعارض والمؤتمرات',
  'UnionBoard.QQG6Dw6f': 'الإدارة والتنظيم',
  'UnionBoard.5zbApfbT': 'المكتب التمثيلي',
  'UnionBoard.czRwXAsE': 'المملكة العربية السعودية',
  'UnionBoard.YHwPEF2J': 'قطر',
  'UnionBoard.B4PfdYR6': 'العراق',
  'UnionBoard.rsSSnCKZ': 'البحرين',
  'UnionBoard.CDGkeN2N': 'اليمن',
  'UnionBoard.zmJ8CsMt': 'كرواتيا',
  'UnionBoard.AYiMiPe4': 'فلسطين',
  'UnionBoard.6A4xh2Qa': 'الإمارات العربية المتحدة',
  'UnionBoard.kpQHnJcT': 'المغرب',
  'UnionBoard.fGBnKNnD': 'الجزائر',
  'UnionBoard.85YXAe3n': 'الكويت',
  'UnionBoard.TdWtT3M8': 'لبنان',
  'UnionBoard.KWmHpA63': 'عمان',
  'UnionBoard.JzWxe6Ry': 'موريتانيا',
  'UnionBoard.5b3i8Bek': 'المكتب الإقليمي',
  'UnionBoard.tZPxXyAC': 'مصر',
  'UnionBoard.BpzzitGH': 'سوريا',
  'UnionBoard.fT3S2RMz': 'الأردن',
  'UnionBoard.EtGHPYN7': 'السودان',
  'UnionBoard.PisFEbWD': 'الآلية',
  'UnionBoard.amEFsjbh': 'الرجل الحكيم',
  'UnionBoard.4KpX5MDN': 'القائد',
  'UnionBoard.QsMpJ8mk': 'العالم',
  'UnionBoard.a3CKYtfA': 'المراهق',
  'UnionBoard.d4cbEAbE': 'حقوق الإنسان',
  'UnionBoard.sH4TDWRi': 'المستشار',
  'UnionBoard.ejw7h5WQ': 'الخبير',
  'UnionBoard.jhQtbDj4': 'الرائد',
  'UnionBoard.e7jPskzH': 'الامرأة',
  'boardOfGeneral.Tc8smGQJ': 'الأمانة',
  'boardOfGeneral.cHMd8eyh': 'القسم',
  'boardOfGeneral.aAtyCHzJ': 'البحث',
  'boardOfGeneral.TZfDZdGi': 'تدريبات تأهيلية',
  'boardOfGeneral.tZMShTJP': 'التجارة',
  'boardOfGeneral.kfYDrHt4': 'الاستثمار',
  'boardOfGeneral.jzcdhcZ6': 'الخدمات',
  'boardOfGeneral.45mkGwcr': 'الصناعة',
  'boardOfGeneral.8G2hTBbA': 'الزراعة',
  'boardOfGeneral.QBWwW66t': 'العلاقات الدولية',
  'boardOfGeneral.6nXKdhHQ': 'المشروع',
  'boardOfGeneral.skbsMhKr': 'صندوق الاستثمار العربي',
  'boardOfGeneral.i8aX82MG': 'المتجر الالكتروني',
  'boardOfGeneral.dZt4pXaa': 'البنك العربي للصادرات',
  'boardOfGeneral.3DHE8KdD': 'الشركة العربية للتجارة الالكترونية',
  'boardOfGeneral.7GcBemw7': 'الشركة العربية للخدمات المالية',
  'boardOfGeneral.hbyXNFD5': 'الشركة العربية للخدمات اللوجستية',
  'boardOfGeneral.hM3hHf6z': 'الشركة العربية للاستثمار الرياضي',
  'boardOfGeneral.pGRZ2eZt': 'الأكاديمية العربية للاقتصاد المعلوماتي',
  'boardOfGeneral.CSY4GmyT': 'مساعد الأمين',
  'boardOfGeneral.tWX4P7KA': 'التخطيط والمتابعة',
  'boardOfGeneral.5b8GmMWn': 'العضوية',
  'boardOfGeneral.3m6SAMPK': 'التنمية البشرية',
  'boardOfGeneral.6AfP3xAE': 'الحساب',
  'boardOfGeneral.MydW8WaR': 'الصحافة',
  'boardOfGeneral.5EyBZXR5': 'إدارة المعارض والمؤتمرات',
  'boardOfGeneral.K5y6wzMJ': 'الإدارة والتنظيم',
  'boardOfGeneral.yDfrPhzG': 'الجهاز',
  'boardOfGeneral.PDbiYb3W': 'منتدى الأعمال العربي الأفريقي الصيني',
  'boardOfGeneral.nfBhxxJZ': 'مركز الوساطة الدولية والتحكيم والوساطة',
  'boardOfGeneral.GPziQXAc': 'المركز العربي لاقتصاد المعلومات',
  'boardOfGeneral.yhSbms4S': 'المركز العربي للتدريب',
  'boardOfGeneral.5d2bH3QB': 'معرفة النادي',
  'boardOfGeneral.GTQR8YY6': 'المسؤولية الاجتماعية',
  'data.eP2ti2aw': 'السوريا',
  'data.trewGJEH': 'قبل الاضطرابات في سوريا عام 2011، كان الاقتصاد ينتقل تدريجيا إلى اقتصاد السوق، لكن هذا لم يكن ناجحا بسبب عوامل متعددة. بعد الاضطرابات التي شهدتها سوريا في عام 2011، فرضت الولايات المتحدة ودول غربية وإقليمية أخرى عقوبات على سوريا. وقد تعرضت سوريا لضغوط متعددة مثل انقطاع صادرات النفط، والانخفاض الحاد في عائدات النقد الأجنبي، وانخفاض قيمة العملة، وارتفاع الأسعار، وارتفاع معدلات البطالة. معدل النمو، والوضع الاقتصادي أصبح خطيرا بشكل متزايد. في يونيو/حزيران 2020، أعلنت الولايات المتحدة تطبيق قانون قيصر الذي فرض عقوبات أحادية الجانب على سوريا. البيانات الاقتصادية الرئيسية هي كما يلي (بسبب الوضع المضطرب في سوريا، يتم تقدير البيانات بشكل أساسي بناءً على السنوات السابقة والوضع الاقتصادي الأخير): الناتج المحلي الإجمالي: 16.5 مليار دولار أمريكي (2021). معدل نمو الناتج المحلي الإجمالي: -2.1% (2021). الناتج المحلي الإجمالي للفرد: 948 دولارًا أمريكيًا (2021). اسم العملة : الليرة السورية. معدل البطالة: 78% (2020). معدل التضخم: 89.2% (2021). احتياطيات النقد الأجنبي: قريبة من الصفر (2022).',
  'data.ab33HBek': 'الاردن',
  'data.CGks7JNM': 'الأردن دولة نامية ذات موارد نادرة نسبيا، وأراضي صالحة للزراعة قليلة، وتعتمد على الواردات. وتشكل التحويلات المالية والسياحة والمساعدات الخارجية الركائز الأساسية للاقتصاد الوطني. بعد أن تولى الملك عبد الله الثاني السلطة، عمل بقوة على تعزيز الإصلاحات الاقتصادية، وتحسين بيئة الاستثمار، وسعى بنشاط للحصول على المساعدات الخارجية، مما أدى إلى عكس النمو السلبي أو الصفري الطويل الأمد للاقتصاد الأردني. في عام 1999، انضمت الصين إلى منظمة التجارة العالمية. وتجاوز معدل النمو الاقتصادي 8% بين عامي 2004 و2008. منذ عام 2009، وبسبب الأزمة المالية العالمية والاضطرابات في غرب آسيا وشمال أفريقيا، انخفض معدل النمو الاقتصادي في نيوزيلندا. وقد كثفت حكومة نيوزيلندا جهودها في التنظيم والرقابة الاقتصادية واتخذت التدابير المقابلة في مجال التمويل والبنية الأساسية. , تشجيع الاستثمار، والمساعدات الخارجية. نتائج مؤكدة. وبعد انتهاء الوباء، انتعشت تجارة الاستيراد والتصدير وعائدات النقد الأجنبي في الأردن تدريجياً، مع زيادة عائدات النقد الأجنبي بنسبة 1.4% في عام 2023 إلى 3.5 مليار دولار أميركي. البيانات الاقتصادية الرئيسية للربع الأول من عام 2024 هي كما يلي: معدل نمو الناتج المحلي الإجمالي: 2.0٪. الناتج المحلي الإجمالي للفرد: حوالي 3891 دولارا أمريكيا. إجمالي احتياطيات النقد الأجنبي: 17.39 مليار دولار أمريكي.',
  introduction: 'المقدمة',
  nationalProject: 'المشاريع الوطنية',
  More: 'اكثر من ذلك',
  noData: 'لا توجد بيانات حتى الآن',
  stateEnterprise: 'المؤسسة الوطنية',
  detail_p1: `وفي الآونة الأخيرة، ومن أجل إفساح المجال كاملاً لدور المنصة الاقتصادية والتجارية الوطنية متعددة الوظائف التابعة لمنظمة شنغهاي للتعاون كجسر وناقل لتعزيز التعاون الاقتصادي والتجاري الدولي والتبادلات الثقافية، وتوسيع مساحة التعاون الاقتصادي والتجاري بين الدول الأعضاء ومنظمة شنغهاي للتعاون . وقع مركز التبادل الدولي التابع لمنصة التجارة الاقتصادية المتعددة الأطراف التابعة لمنظمة شنغهاي للتعاون واتحاد المستوردين والمصدرين العرب مذكرة تعاون.`,
  detail_p2: `وبموجب الاتفاقية، سيعمل الجانبان بشكل نشط على تعزيز الشركات من منظمة شنغهاي للتعاون وغيرها من البلدان والمناطق بما في ذلك الصين والدول العربية في مجالات النقل، ويخلق التعاون الدولي في مجالات مثل اللوجستيات الدولية والطاقة والتمويل والتجارة الدولية والتكنولوجيا الصناعية ظروفاً مواتية لتعميق الاستثمار الثنائي والتعاون التكنولوجي والصناعي.`,
  detail_p3: `وبموجب الاتفاقية، سيعمل الجانبان بشكل نشط على تعزيز الشركات من منظمة شنغهاي للتعاون وغيرها من البلدان والمناطق بما في ذلك الصين والدول العربية في مجالات النقل، ويخلق التعاون الدولي في مجالات مثل اللوجستيات الدولية والطاقة والتمويل والتجارة الدولية والتكنولوجيا الصناعية ظروفاً مواتية لتعميق الاستثمار الثنائي والتعاون التكنولوجي والصناعي.`,
  textList_01: 'تقرير منتدى الاستثمار',
  textList_02: 'جمعية غرف المقاصة للمصدرين',
  textList_03: 'وزير الاستثمار في المنتدى الاقتصادي العاشر',
  textList_04: 'بدون عنوان',
  textList_05: 'بدون عنوان',
  arabAfrican_01: `ينشأ عن اتحاد المصدرين والمستوردين العرب منتدى مستقل ويتمتع بالشخصية المعنوية المستقلة يسمى "منتدى الأعمال العربي الصيني".`,
  arabAfrican_02: `يهدف المنتدى إلى خلق التفاعل وتعزيز العلاقات والتعاون والتنسيق بين رجال الأعمال العرب ورجال الأعمال الصينيين من مختلف القطاعات الاقتصادية لتعزيز التكامل الاقتصادي العربي الصيني لتحقيق الأهداف التالية:`,
  arabAfrican_03: `1) توثيق وتطوير العلاقات الاقتصادية بين رجال الأعمال العرب والصينيين في إطار مبادرة طريق الحرير.`,
  arabAfrican_04: `2) زيادة حجم التبادل التجاري بين الدول العربية والصين، وبحث البرامج والآليات الكفيلة بتحقيق ذلك، وتحديد المعوقات، ووضع الحلول العملية التي تساعد على إزالتها.`,
  arabAfrican_05: `3) التعاون مع المؤسسات العربية والصينية المعنية بتنمية التجارة البينية العربية والاستفادة من برامج هذه المؤسسات المالية والفنية والتأكيد على أهمية دورها في تعزيز العمل الاقتصادي العربي الصيني المشترك.`,
  arabAfrican_06: `4) تعزيز المشاريع العربية الصينية المشتركة في إطار تكاملي طويل الأمد.`,
  arabAfrican_07: `5) تقديم سلسلة من العروض الخاصة ببيئة الاستثمار في الصين والتجارب الصناعية والمسار المؤسسي الناجح والاستفادة من التجارب وتبادل الخبرات بين المشاركين.`,
  arabAfrican_08: `6) خلق بيئة عمل نموذجية وفتح آفاق جديدة لرجال وسيدات الأعمال العرب والصينيين.`,
  arabAfrican_09: `7) تطوير أفكار رائدة من شأنها أن تعود بالنفع على الاقتصاد العربي من خلال بناء المشاريع المشتركة وتطوير الصناعات. `,
  arabAfrican_10: `8) تنظيم الأنشطة الاقتصادية وتنشيط الأعمال وفرص الاستثمار والشراكات والاستثمار.`,
  arabAfrican_11: `أنشطة المنتدى:`,
  arabAfrican_12: `1) تنظيم وعقد لقاءات نصف سنوية بين رجال الأعمال العرب والصينيين تحت مسمى "منتدى الأعمال العربي الصيني" في الدول العربية والمقاطعات الصينية التي ترغب في استضافة مثل هذه اللقاءات.`,
  arabAfrican_13: `2) تنظيم وعقد لقاءات قطاعية في مجالات التجارة والصناعة والزراعة والسياحة والنقل والمقاولات والمصارف أو أي قطاعات اقتصادية أخرى بهدف التنسيق بين رجال الأعمال العرب والصينيين العاملين في هذه المجالات.`,
  arabAfrican_14: `3) تنظيم المؤتمرات واللقاءات التجارية (B2B) والمعارض الدائمة والموسمية في الدول العربية ومقاطعات الصين.`,
  arabAfrican_15: `4) إعداد الدراسات الاقتصادية المتخصصة.`,
  arabAfrican_16: `5) إنشاء وإدارة المجمعات التجارية وصالات العرض في المحافظات العربية والصينية.`,
  arabAfrican_17: `6) العمل كحلقة وصل بين الوزارات والمؤسسات والمنظمات والمنظمات العربية والصينية لتسهيل العلاقات الاقتصادية وتذليل العقبات أمام تدفق الأموال والأشخاص والبضائع بين الدول العربية والصين.`,
  arabAfrican_18: `7) تمثيل الوزارات والمؤسسات والمنظمات العربية والصينية في التعامل مع المؤسسات الأجنبية المماثلة.`,
  arabAfrican_19: `8) المشاركة في اللقاءات العربية والصينية والدولية المتعلقة بأنشطة رجال الأعمال العرب والصينيين. `,
  arabAfrican_20: `9) فتح قنوات التعاون مع المجموعات الاقتصادية الإقليمية لتحقيق مكاسب مختلفة لمجتمع الأعمال العربي الصيني.`,
  arabAfrican_21: `10) تنظيم دورات وندوات تدريبية عامة وقطاعية في الدول العربية أو المقاطعات الصينية أو عواصم العالم لإظهار دور وأهمية منتدى الأعمال العربي الصيني كجهة راعية لأنشطة رجال الأعمال العرب والصينيين.`,
  arabAfrican_22: `11) إصدار الدليل التجاري العربي الصيني دورياً باللغتين العربية والصينية والإنجليزية، وإصدار النشرات الدورية والإعلامية.`,
  arabAfrican_23: `12) إنشاء بوابة متخصصة للمختصين.`,
  arabAfrican_24: `13) النظر في كافة النزاعات التجارية بين الشركات العربية والصينية أو بينها وبين الغير سواء كانوا أشخاصاً طبيعيين أو اعتباريين.`,
  arabAfrican_25: `14) تقديم الاستشارات القانونية المتخصصة في العقود التجارية.`,
  arabAfrican_26: `15) صياغة وكتابة العقود التجارية المحلية والإقليمية والدولية.`,
  arabAfrican_27: `16) القيام بالمراقبة القانونية ومتابعة تنفيذ العقود التجارية.`,
  arabFundTitle1: 'مجلس الوحدة الاقتصادية العربية ',
  arabFundTitle2: 'إتحاد المصدرين والمستوردين العرب',
  xiaomifeng_001: `
ترتبط "مجموعة النحلة العربية للخدمات المالية" تنظيمياً بإتحاد المصدرين والمستوردين العرب 
)أحد اﻹتحادات العربية النوعية المتخصصة، العاملة في نطاق مجلس الوحدة اﻹقتصادية العربية(، 
وتملك المجموعة الشخصية اﻹعتبارية وتتمتع باﻹستقﻻل المالي واﻹداري
وتملك تامجموعة الشخصية الاعتبارية وتتمتع بالاستقلال المالي والاداري 
رأس مال المجموعة:
رأس مال المجموعة خمسمائة مليون دوﻻر أمريكي.
أهداف "مجموعة النحلة العربية للخدمات المالية" في الدول العربية وجمهورية الصين
الشعبية:
التعاون يداً بيد مع وزارات المالية في الدول العربية لتطوير بنية تحتية سليمة للقطاع المالي 
وإنشاء أسواق محلية لرأس المال، والتشجيع على تنمية القطاع المالي الخاص، وتحسين قدرة اﻷفراد 
ومؤسسات اﻷعمال الصغيرة على المشاركة والحصول على التمويل، وتعزيز اﻻستقرار المالي في 
الدول العربية، وتطوير أنظمة مالية تتسم بالتنوع، والكفاءة، والشمولية، على الصعيدين العربي
والصيني.
خدمات "مجموعة النحلة العربية للخدمات المالية" في الدول العربية وجمهورية الصين 
الشعبية:
التجارة اﻹلكترونية:
B2B-اﻷعمال إلى اﻷعمال.
B2G-اﻷعمال الموجهة إلى الحكومات.
B2C-اﻷعمال إلى المستهلك.
B2B-المستهلك إلى اﻷعمال التجارية. 
C2C-المستهلك إلي المستهلك. 
الدفع اﻹلكتروني:
المحافظ اﻹلكترونية.
أنظمة الدفع بالتقسيط.
الدفع اﻹلكتروني الذكي.
تحويل اﻷموال محلياً ودولياً.
تمويل اﻷفراد:
دفع اﻷجور والدفعات النقدية الشهرية.
تمويل المشتريات.
قروض حسنة.
تمويل متخصص )تعليم –صحة –زواج –وغيرها(.
تمويل المؤسسات الصغيرة:
تمويل المشروعات الصغيرة والمتناهية الصغر.
تمويل مشتريات اﻵﻻت ومستلزمات اﻹنتاج.
إعادة هيكة المشروعات الصغيرة المتعثرة.
تمويل الصادرات. 
اﻹستثمار المتناهي الصغر:
إتاحة اﻹستثمار في الشركت العربية والدولية المتميزة أمام الطبقات الوسطي والمحدودة الدخل 
في الدول العربية، وذلك عن طريق تقسيم أسهم الشركت إلى فئات متعددة )ميكرو سهم( يسهل 
التعامل عليها من جميع مستويات الشعوب العربية.
التأمين:
التأمين على القروض المحلية والدولية.
التأمين على الصادرات والواردات.
التأمين الصحي.
التأمين الصحي.
التأمين على أدوات الركوب.
التأمين ضد الحوادث.
التحكيم والوساطة:
التحكيم التجاري.
فض المنازعات.
الوساطة التجارية.
الخدمات اللوجستية:
الشحن المحلي والدولي.
النقل المحلي والدولي.
التعبئة التغليف.
التخليص الجمركي.
إنشاء وإدارة المنافذ الحدودية.
إنشاء وإدارة المناطق اللوجستية.
نتطلع لمشاركة قوية منرجال اﻷعمال والشركت الصينية والدولية 
وتفضلوا بقبول فائق الشكر والتقدير واﻹحترام
  `,
  founder_01: `أسس اإلتحاد السيدة: أمل حسن زكي، وأعلنت عن تأسيسه بتاريخ: 2005/12/25.`,
  founder_02: `اإلتحاد، منظمة عربية دولية تعمل تحت مسمي ”إتحاد المصدرين والمستوردون العرب" وهو أحد 
اإلتحادات العربية النوعية المتخصصة العاملة في نطاق مجلس الوحدة اإلقتصادية العربية، وذلك 
وفقاً إلتفاقية األحاكم األساسية التي صادقت عليها البرلمانات العربية، وأصحاب الجاللة والفخامة 
ملوك ورؤساء الدول العربية.`,
  founder_03: `وصدر قرار إنضمام اإلتحاد إلى مجلس الوحدة اإلقتصادية العربية، خالل إنعقاد الدورة العادية 
الثالثة والثمانين المنعقدة في القاهرة بتاريخ: 2006/6/7، وصدر قرار اإلنضمام برقم: 1310/د 83
.2006/6/7 :بتاريخ ا`,
  founder_title_01: `تأسيس اإلتحاد:`,
  founder_title_02: `شرعية اإلتحاد:`,
}
